module.exports = __webpack_public_path__ + "static/media/cef-logo.7b80125f.svg";